import React  from 'react';
import './App.css';
import AboutLang from './AboutLang.json';

class About extends React.Component {

	renderOneItem(dateString, textArray) {
		
		var i;
		var key;
		var text1;
		var text2;
		var jsxCode;
		var jsxArray = [];
		
		for(i=0; i<textArray.length; i++) {
			key = dateString + "-" + i;
			text1 = textArray[i];
			text2 = this.props.getLang(AboutLang, text1);
			jsxCode = (<div key={key}>{text2}</div>);
			jsxArray.push(jsxCode);
		}
		
		return (
			<div>
				<div className="AboutDateString">{dateString}</div>
				<div className="AboutInfoText">{jsxArray}</div>
				<div style={{height: "15px"}}></div>
			</div>
		);
	}

	render() {
		return (
			<div style={{paddingLeft: "20px", paddingRight: "	20px"}}>
				<div style={{height: "20px"}}></div>
				<div className="AboutTitle">{this.props.getLang(AboutLang, "about")}</div>
				<div style={{height: "20px"}}></div>
				{this.props.getLang(AboutLang, "appGoals")}
				<div style={{height: "20px"}}></div>
				{this.renderOneItem("10/2025", ["plainTextSources", "wordSources", "exportToExcelWord"])}
				{this.renderOneItem("07/2025", ["settings", "processingQueue", "createPodcast", "restAPI"])}
				{this.renderOneItem("06/2025", ["addSourceImplemented", "newNotebookImplemented", "downloadExcelImplemented", "editPromptImplemented", "chatImplemented"])}
				{this.renderOneItem("05/2025", ["notebookListImplemented", "notebookMainImplemented"])}
				{this.renderOneItem("04/2025", ["developmentStarted"])}
			</div>
		);
	}
}

export default About;

